import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Card, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import axios from "axios";

const Login = () => {
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.username) newErrors.username = "Username is required";
    else if (!/^[a-zA-Z0-9@]+$/.test(formData.username)) newErrors.username = "Only letters, numbers, @ allowed";
    else if (formData.username.length < 3) newErrors.username = "Must be at least 3 chars";
    if (!formData.password) newErrors.password = "Password is required";
    else if (/\s/.test(formData.password)) newErrors.password = "No spaces allowed";
    else if (formData.password.length < 6) newErrors.password = "Must be at least 6 chars";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);
    try {
      const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
      const response = await axios.post(`${base}/api/admin/login`, {
        username: formData.username,
        password: formData.password
      }, { withCredentials: true });
      if (response.status === 200 && response.data?.token) {
        localStorage.setItem("token", response.data.token);
        toast.success("Login successful!");
        setTimeout(() => (window.location.href = "/dashboard"), 800);
      } else {
        toast.error(response.data?.message || "Login failed");
      }
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status === 401) toast.error("Invalid username or password");
        else toast.error(error.response.data?.message || `Error ${status}`);
      } else if (error.code === "ECONNABORTED") {
        toast.error("Request timeout. Try again.");
      } else {
        toast.error("Network or server error");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container d-flex align-items-center justify-content-center" style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "#f8f9fa" }}>
      <Container fluid className="h-100">
        <Row className="justify-content-center align-items-center h-100">
          <Col xs={12} sm={8} md={6} lg={4}>
            <Card className="shadow-lg">
              <Card.Body className="p-5">
                <div className="text-center mb-4">
                  <h2 className="fw-bold text-primary">Login</h2>
                  <p className="text-muted">Sign in to your ATS account</p>
                </div>
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>Username</Form.Label>
                    <Form.Control
                      type="text"
                      name="username"
                      value={formData.username}
                      onChange={handleChange}
                      placeholder="Enter your username"
                      isInvalid={!!errors.username}
                      className="py-2"
                    />
                    <Form.Control.Feedback type="invalid">{errors.username}</Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="mb-4">
                    <Form.Label>Password</Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        placeholder="Enter your password"
                        isInvalid={!!errors.password}
                        className="py-2 pe-5"
                      />
                      <Button
                        variant="outline-secondary"
                        className="position-absolute end-0 top-0 h-100 px-3 border-0"
                        style={{ zIndex: 1 }}
                        onClick={() => setShowPassword(!showPassword)}
                        type="button"
                      >
                        <i className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
                      </Button>
                      <Form.Control.Feedback type="invalid">{errors.password}</Form.Control.Feedback>
                    </div>
                  </Form.Group>
                  <Button type="submit" variant="primary" className="w-100 py-2 fw-semibold" disabled={loading}>
                    {loading ? (
                      <>
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                        Signing in...
                      </>
                    ) : (
                      "Login"
                    )}
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;